/**
 * User: craig
 * Date: 4/25/14
 * Time: 2:19 PM
 * Copyright (c) 2014 Absolute Hero, Inc.
 */
define('absolute/stringmanager',['lodash'],
	function (_) {

		var _strings = {};
		var supportedLanguages = [
			'en-US', 'es-ES', 'fr-FR', 'fr-CA', 'de-DE',
			'it-IT', 'ja-JP', 'nb-NO', 'pt-BR', 'pt-PT',
			'ru-RU', 'sv-SE', 'zh-CN', 'zh-HK', 'zh-TW'
		];
		var _locale = getUserLanguage();

		function lookup(key, locale, getArray) {
			var i = 0,
				kf = key.split("."),
				s = _strings[locale];

			while (s && typeof s === "object") {
				if (getArray && Object.prototype.toString.call(s[kf[i]]) === '[object Array]') {
					return s[kf[i]];
				}
				s = s[kf[i++]];
			}

			return s;
		}

		var StringManager = function (key, args, getArray) {

			getArray = !!getArray;

			var s = lookup(key, _locale, getArray) || lookup(key, "en-US", getArray);

			if (s && typeof s == "string" && s !== "" && args && args.length > 0) {
				for (var i = 0; i < args.length; i += 1) {
					s = s.replace("%" + i, String(args[i]));
				}
			}
			return s || key;
		};


		StringManager.setLocale = function (locale) {
			_locale = locale;
		};

		StringManager.load = function (s) {
			_.merge(_strings, s);
		};

		StringManager.getUserLanguage = function () {
			return getUserLanguage();
		};

        function getUserLanguage() {
            var lang;

            var qs = getQueryParameter('locale');
            if (qs) {
                qs = qs.toLowerCase();

                lang = supportedLanguages
                    .filter(function (l) {
                        return l.toLowerCase() === qs || l.toLowerCase().indexOf(qs) !== -1;
                    })[0];
            }

            if (!lang) {
                var browserLanguage = navigator.languages
                    ? navigator.languages[0]
                    : (navigator.language || navigator['userLanguage']);

                lang = supportedLanguages
                    .filter(function (l) {
                        return l === browserLanguage || l.indexOf(browserLanguage) !== -1;
                    })[0];
                lang = lang || supportedLanguages[0];
            }
            return lang;
        }

        function getQueryParameter(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }


		StringManager.shrinkToFit = function (textObj, size, type, allowedWidth, allowedHeight) {
			while (((allowedWidth && textObj.width > allowedWidth) ||
				(allowedHeight && textObj.height > allowedHeight)) && size > 1) {
				size -= 1;
				textObj.style.font = [type, ' ', size, 'px Arial'].join('');
				textObj.updateText();
			}
		};

		StringManager.enlargeText = function (textObj, size, type, allowedWidth, allowedHeight) {
			if (!allowedWidth || !allowedHeight) return;
			while (textObj.width < allowedWidth && textObj.height < allowedHeight) {
				size++;
				textObj.style.font = [type, ' ', size, 'px Arial'].join('');
				textObj.updateText();
				if (textObj.width > allowedWidth) {
					textObj.style.font = [type, ' ', size--, 'px Arial'].join('');
					break;
				}
			}
		};

		StringManager.extractNumbersFromString = function (str) {
			return str.replace(/[^0-9^.]/g, '');
		};

		StringManager.doesUserLanguageSupportWordWrap = function () {
			var usrLang = getUserLanguage();
			return (
				usrLang !== 'zh-CN' && usrLang !== 'ja-JP' &&
				usrLang !== 'zh-TW' && usrLang !== 'zh-HK'
			);
        };

        StringManager.capitalize = function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);

        };

		return StringManager;
	});

